<template>
    <div class="spinner-container">
        <div>
            <div class="spinner"></div>
            <p class="is-size-5 has-text-primary has-text-centered">
                {{ label }}
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Spinner",
        props: {
            label: {
                type: String,
                default: "Betöltés..."
            }
        }
    }
</script>

<style scoped>

</style>